import { render } from "./CampaignDrawer.vue?vue&type=template&id=52990a00&scoped=true"
import script from "./CampaignDrawer.vue?vue&type=script&lang=js"
export * from "./CampaignDrawer.vue?vue&type=script&lang=js"

import "./CampaignDrawer.vue?vue&type=style&index=0&id=52990a00&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52990a00"]])

export default __exports__